import { getProductPageEntries, type ProductPageSelection } from '../getProductPageEntries';

export const getProductsAmount = (page: ProductPageSelection): number =>
  getProductPageEntries(page).length;
